import { Flex, Text, Collapse, Box } from "@chakra-ui/react";
import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { BaseInput } from "../BaseInput";

interface SalesMaxOfferBlockProps {
  valueGeneral: string;
  value1: string;
  value2: string;
  idGeneral: string;
  id1: string;
  id2: string;
  onChangeGeneral: (value: string) => void;
  onChange1: (value: string) => void;
  onChange2: (value: string) => void;
  requiredField?: boolean;
}

export const SalesMaxOfferBlock = ({
  valueGeneral,
  value1,
  value2,
  idGeneral,
  id1,
  id2,
  onChangeGeneral,
  onChange1,
  onChange2,
  requiredField = false,
}: SalesMaxOfferBlockProps) => {
  const hasAnyValue = Boolean((valueGeneral && valueGeneral.length > 0) || (value1 && value1.length > 0) || (value2 && value2.length > 0));
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => setIsOpen((prev) => !prev);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsOpen((prev) => !prev);
    }
  };

  return (
    <Box borderWidth="1px" borderColor="#3B82F6" borderRadius="md" bg="gray.50">
      <Flex
        as="button"
        type="button"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        px="3"
        py="2"
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={`${idGeneral}-collapse`}
        bg="#3B82F6"
        color="white"
      >
        <Text fontSize="md" fontWeight="semibold" color="white">
          Max ставка продажи
          {requiredField && (
            <Text as="span" color="red.500" ml="1">
              *
            </Text>
          )}
        </Text>
        <Flex alignItems="center" gap="8px">
          {!isOpen && (
            <Text fontSize="sm" color="white" fontWeight="bold">
              Развернуть
            </Text>
          )}
          {isOpen ? <ChevronUpIcon color="white" /> : <ChevronDownIcon color="white" />}
        </Flex>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Flex flexDirection="row" gap="24px" p="12px" alignItems="flex-start">
          <BaseInput
            fieldTitle={"Max ставка продажи (Общая)"}
            id={idGeneral}
            value={valueGeneral}
            onChange={(e) => onChangeGeneral((e.target as HTMLInputElement).value)}
            containerStyles={{ width: "33%" }}
          />
          <BaseInput
            fieldTitle={"Max ставка продажи (МСК и МО)"}
            id={id1}
            value={value1}
            onChange={(e) => onChange1((e.target as HTMLInputElement).value)}
            containerStyles={{ width: "33%" }}
          />
          <BaseInput
            fieldTitle={"Max ставка продажи (Регион)"}
            id={id2}
            value={value2}
            onChange={(e) => onChange2((e.target as HTMLInputElement).value)}
            containerStyles={{ width: "33%" }}
          />
        </Flex>
      </Collapse>
      {requiredField && (
        <Text fontSize="xs" color="red.500" mt="2" px="3" pb="2">
          Обязательное поле
        </Text>
      )}
    </Box>
  );
};
